import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "main-section",
  role: "main"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TheHeader = _resolveComponent("TheHeader")
  const _component_FloatingNavigation = _resolveComponent("FloatingNavigation")
  const _component_router_view = _resolveComponent("router-view")
  const _component_LoadingScreen = _resolveComponent("LoadingScreen")
  const _component_TheFooter = _resolveComponent("TheFooter")
  const _component_CookieGate = _resolveComponent("CookieGate")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_TheHeader, null, null, 512), [
      [_vShow, $options.shouldShowHeader]
    ]),
    _createElementVNode("main", _hoisted_1, [
      ($options.shouldShowNavigation)
        ? (_openBlock(), _createBlock(_component_FloatingNavigation, { key: 0 }))
        : _createCommentVNode("", true),
      (_openBlock(), _createBlock(_component_router_view, {
        key: _ctx.$route.fullPath,
        class: "content"
      })),
      ($options.showLoadingScreen)
        ? (_openBlock(), _createBlock(_component_LoadingScreen, {
            key: 1,
            onAssetsLoaded: _cache[0] || (_cache[0] = $event => ($data.assetsLoaded = true))
          }))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createVNode(_component_TheFooter, null, null, 512), [
      [_vShow, $options.shouldShowFooter]
    ]),
    _createVNode(_component_CookieGate, {
      "body-copy": $setup.t('cookie_gate:alternate_copy'),
      "button-copy": $setup.t('cookie_gate:button_copy'),
      "button-type": "x",
      "title-copy": $setup.t('cookie_gate:title')
    }, null, 8, ["body-copy", "button-copy", "title-copy"])
  ], 64))
}